import { addHours, isBefore } from 'date-fns';

const AMEND_ROLES = ['supervisor', 'safety_manager', 'tenant_admin', 'platform_admin'];

export function canAmend(
  dsr: { status: string; submitted_at: string | null; created_by: string },
  currentUserId: string,
  userRole: string
): boolean {
  if (dsr.status !== 'submitted') return false;
  if (!dsr.submitted_at) return false;

  const deadline = addHours(new Date(dsr.submitted_at), 24);
  if (!isBefore(new Date(), deadline)) return false;

  return currentUserId === dsr.created_by || AMEND_ROLES.includes(userRole);
}

export function amendDeadline(submittedAt: string): Date {
  return addHours(new Date(submittedAt), 24);
}
